import { useNavigate } from "react-router-dom";
import UnauthorisedPage from "../components/display/UnauthorisedPage";

type Props = {
  envCondition: boolean;
  children?: React.ReactNode;
};

const RequireEnv = ({ envCondition, children }: Props) => {
  const navigate = useNavigate();

  return envCondition ? (
    children
  ) : (
    <UnauthorisedPage
      errorTitle="Access denied"
      actionText="Go to homepage"
      action={() => navigate("/")}
    />
  );
};
export default RequireEnv;
